import { getOrdersList } from "@NA/Services/ADIOrdersListService";
import { CustomHandlerWithResult } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { GetOrdersListApiParameter, GetTrackingOrdersListApiParameter,GetOrderListApiParameter, OrderCollectionModel } from "@insite/client-framework/Types/ApiModels";

interface Props {
    ordersList: OrderCollectionModel;
}

type HandlerType = CustomHandlerWithResult<GetOrdersListApiParameter, Props>;
type HandlerTrackingOrderType = CustomHandlerWithResult<GetTrackingOrdersListApiParameter, Props>;
type HandlerOrderType = CustomHandlerWithResult<GetOrderListApiParameter, Props>;

export const DispatchLoadOrdersList: HandlerType = (props: any) => {
    props.dispatch({
        type: "Custom/DispatchLoadOrdersList",
    });
};

export const LoadOrdersList: HandlerType = async (props: any) => {
    const parameter = props.parameter;
    if (!parameter) {
        return false;
    }
    const ordersList = await getOrdersList(parameter);

    if (ordersList) {
        props.ordersList = ordersList;
    }

    if (!props) {
        return false;
    }
};

// export const TrackOrdersList: HandlerTrackingOrderType = async (props: any) => {
//     if (!props) {
//         return false;
//     }

//     const trackingOrdersList = await getTrackOrdersList(props);

//     if (trackingOrdersList) {
//         props.trackingOrdersList = trackingOrdersList;
//     }
// };

// export const getkOrdersList: HandlerOrderType = async (props: any) => {  
//     if (!props) {
//         return false;
//     }
//     const trackingOrdersList = await getOrderDetails(props);

//     if (trackingOrdersList) {
//         props.trackingOrdersList = trackingOrdersList;
//     }
// };

export const DispatchCompleteLoadOrdersList: HandlerType = (props: any) => {
    props.dispatch({
        type: "Custom/DispatchCompleteLoadOrdersList",
        ordersList: props.ordersList ?? [],
    });
};

export const DispatchCompleteTrackinOrderList: HandlerTrackingOrderType = (props: any) => {
    props.dispatch({
        type: "Custom/DispatchCompleteTrackinOrderList",
        trackingOrdersList: props.trackingOrdersList ?? [],
    });
};

export const chain: any = [DispatchLoadOrdersList, LoadOrdersList, DispatchCompleteLoadOrdersList, DispatchCompleteTrackinOrderList];

const loadOrdersList = createHandlerChainRunner(chain, "LoadOrdersList");
export default loadOrdersList;
